import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import LoadingSwitchTransition from '@/components/LoadingSwitchTransition';
import PlaceholderLoading from '@/components/PlaceholderLoading';
import ProtocoloExecutadoDetail from '@/features/execucao/components/ProtocoloExecutadoDetail/index.b2b';
import { useExecucaoContext } from '@/features/execucao/providers/ExecucaoProvider';
import ExecucaoService from '@/features/execucao/services/ExecucaoAPI';
import { useQuery } from '@/utils/route';

import EnterpriseHeaderProtocoloExecutado from '../../components/EnterpriseHeaderProtocoloExecutado';
import { useEnterpriseContext } from '../../contexts/EnterpriseContext';
import EnterprisePageLayout from '../../layouts/EnterprisePageLayout';

const PlaceholderContent = () => (
  <PlaceholderLoading.Rect
    height={513}
    width="100%"
    style={{
      display: 'flex',
      borderRadius: 16,
    }}
  />
);

const VisualizacaoProtocoloEnterprise: React.FC = () => {
  const history = useHistory();
  const query = useQuery();
  const protocoloId = useParams<{ id: string }>().id;
  const [isLoadingProtocolo, setIsLoadingProtocolo] = useState(true);
  const [
    { protocoloExecutado },
    { dispatchSetExecucaoResumo },
  ] = useExecucaoContext();
  const [, { dispatchStartFromExecution }] = useEnterpriseContext();

  const disableNavigation = React.useMemo(() => {
    return query.get('disable_navigation') === 'true';
  }, [query]);

  React.useEffect(() => {
    if (protocoloExecutado) {
      setIsLoadingProtocolo(false);
    }
  }, [protocoloExecutado]);

  React.useEffect(() => {
    if (!isLoadingProtocolo && !protocoloExecutado) {
      history.replace('/');
    }
  }, [history, isLoadingProtocolo, protocoloExecutado]);

  React.useEffect(() => {
    async function loadProtocolo() {
      try {
        const execucao = await ExecucaoService.getExecucaoResumo(protocoloId);
        dispatchSetExecucaoResumo(execucao);
        dispatchStartFromExecution(execucao);
      } catch {
        history.replace('/unauthorized');
      }
    }

    loadProtocolo();
    // eslint-disable-next-line
  }, []);

  if (disableNavigation) {
    return <ProtocoloExecutadoDetail />;
  }

  return (
    <EnterprisePageLayout Nav={<EnterpriseHeaderProtocoloExecutado />}>
      <LoadingSwitchTransition
        loading={isLoadingProtocolo}
        LoadingComponent={<PlaceholderContent />}
        style={{
          flex: 1,
        }}
      >
        <ProtocoloExecutadoDetail />
      </LoadingSwitchTransition>
    </EnterprisePageLayout>
  );
};

export default VisualizacaoProtocoloEnterprise;
